import LogoLight from "/logo.svg";
import LogoDark from "/logo-dark.svg";

export function Logo() {
    return (
        <>
            <img className="block dark:hidden" alt="logo" src={LogoLight} />
            <img className="hidden dark:block" alt="logo" src={LogoDark} />
        </>
    );
}
